import React, { useEffect } from 'react'
import { useState } from 'react'
import Spinner from '../../../components/Spinner/Spinner'
import { runQuery } from '../../../dato'
import Teaser from './Teaser'
import { useInView } from 'react-intersection-observer'
import { query as relatedStoriesQuery } from '../queries/relatedStoriesQuery'
import { recipesDataQuery } from '../queries/categoryQuery'
import RecipeTeaser from './RecipeTeaser'
import { RelatedStories_allNutritionArticles } from '../queries/types/RelatedStories'
import { AllNutritionRecipes_allRecipes } from '../queries/types/AllNutritionRecipes'

type Props = {
  category: { id: string } | 'recipes'
  max?: number
  not: string
}

export default function RelatedStories({ category, max = 6, not }: Props) {
  const [inViewRef, inView] = useInView({ triggerOnce: true })
  const [stories, setStories] = useState<
    | Array<RelatedStories_allNutritionArticles>
    | Array<AllNutritionRecipes_allRecipes>
  >([])

  useEffect(() => {
    if (inView) {
      const finish = (stories) => {
        setStories(
          not
            ? stories.filter((story) => story.id !== not).slice(0, max)
            : stories,
        )
      }

      if (category === 'recipes') {
        runQuery(recipesDataQuery, {
          first: max + 1,
        }).then(({ allRecipes }) => finish(allRecipes))
      } else {
        runQuery(relatedStoriesQuery, {
          category: category.id,
          first: max + 1,
        }).then(({ allNutritionArticles }) => finish(allNutritionArticles))
      }
    }
  }, [inView, category, max, not])

  return (
    <div ref={inViewRef} className="text-center">
      {stories.length === 0 ? (
        <Spinner width="50" color="grey-lightest" className="mt-40" />
      ) : (
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-6 xl:gap-10">
          {stories.map((story) => {
            return category === 'recipes' ? (
              <RecipeTeaser key={story.id} {...story} />
            ) : (
              <Teaser
                key={story.id}
                {...story}
                slug={story.slug as string}
                title={story.title ? story.title : undefined}
                big
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
